export const COUNTRY_LIST = 'COUNTRY_LIST';
export const COUNTRY_LIST_SUCCESS = 'COUNTRY_LIST_SUCCESS';
export const COUNTRY_LIST_FAILURE = 'COUNTRY_LIST_FAILURE';
